var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('o-view',[_c('o-nav-bar',{attrs:{"title":"Mijn tickets","has-back-button":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }